import React, { useMemo } from 'react'
import { useLocation } from 'react-router-dom'

import compact from 'lodash/compact'
import toUpper from 'lodash/toUpper'

import { useT } from '@galo-monitor/i18n'
import Screen from '@galo-monitor/web-components/Screen'
import TabsPanelRoutes from '@galo-monitor/web-components/TabsPanelRoutes'
import { useRoutes } from '@galo-monitor/web-containers/routes/authenticated'

import Plots from './tabs/Plots'
import PropertyOverviewMap from './tabs/PropertyOverviewMap'

const MapsScreen = () => {
  const { pathname } = useLocation()
  const { routes, urlHasPermission } = useRoutes()
  const t = useT()

  const tabs = useMemo(
    () => {
      const response = []

      const addTab = tab => {
        if (urlHasPermission(tab.slug, 'farm')) {
          response.push(tab)
        }
      }

      addTab({
        route: 'plots',
        slug: 'gerenciamento-de-mapas-farm',
        title: toUpper(t('plot', { howMany: 2 })),
        Component: Plots
      })

      addTab({
        route: 'general',
        slug: 'gerenciamento-de-mapas-farm',
        title: toUpper(t('property overview map')),
        Component: PropertyOverviewMap
      })

      return response
    },
    [t, urlHasPermission]
  )

  const crumbs = useMemo(() => compact([
    {
      title: routes.maps.title,
      key: 'property-maps-screen',
      url: '/maps',
      active: pathname === '/maps'
    },
    (
      pathname.includes('plots') ? {
        title: t('plot', { howMany: 2 }),
        key: 'property-plots-screen',
        url: '/maps/plots',
        active: pathname === '/maps/plots'
      } : null
    ),
    (
      pathname.includes('general') ? {
        title: t('property overview map'),
        key: 'property-general-map-screen',
        url: '/maps/general',
        active: pathname === '/maps/general'
      } : null
    )
  ]), [pathname, routes.maps.title, t])

  return (
    <Screen title={ routes.maps.title } breadcrumbs={ crumbs } removeDivider>
      <TabsPanelRoutes itens={ tabs } />
    </Screen>
  )
}

export default MapsScreen
